/**
 * Grid Component
 *
 * A container that arranges children in a 2D grid.
 * Component follows Smoothie UI architecture.
 *
 * @module @smoothie-framework/ui/components
 */
import { createNodeId } from '../../render/node-id';
import { BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS } from '@smoothie-framework/ui-styles/styling/contract';
import { normalizeChildrenToNodes } from '../../internal/children';
import { withResponsiveBaseFallback } from '../../authoring/internal';
import { resolveCanonicalUtilityProps, } from '../../authoring/utility-props';
import { composeAsChildNode } from '../../authoring/as-child';
import { buildCommonUIProps, } from '../../authoring/common-props';
export function Grid(props) {
    const { id, columns: columnsProp, cols, rows, areas, flow, autoRows, autoColumns, inline, asChild, alignItems, justifyContent, justifyItems, alignContent, placeContent, placeItems, gap = defaultGridProps.gap, align, justify, as, style, role, ariaLabel, ariaLabelledBy, 'aria-labelledby': ariaLabelledByAttribute, ariaDescribedBy, className, children, 'data-ui': dataUi, ...utilityPropsInput } = props;
    const classes = ['smth-grid'];
    const columns = columnsProp ?? cols;
    const resolvedColumns = columns !== undefined ? withResponsiveBaseFallback(columns, DEFAULT_GRID_COLUMNS) : undefined;
    const resolvedGap = withResponsiveBaseFallback(gap, defaultGridProps.gap);
    if (className) {
        classes.push(className);
    }
    const gridProps = {
        className: classes.join(' '),
        ...(typeof as === 'string' && as.length > 0 && { 'data-as': as }),
        ...resolveCanonicalUtilityProps({
            ...utilityPropsInput,
            ...(resolvedColumns !== undefined && { columns: resolvedColumns }),
            rows,
            areas,
            flow,
            autoRows,
            autoColumns,
            inline,
            ...(alignItems !== undefined && { alignItems }),
            ...(justifyContent !== undefined && { justifyContent }),
            ...(justifyItems !== undefined && { justifyItems }),
            ...(alignContent !== undefined && { alignContent }),
            ...(placeContent !== undefined && { placeContent }),
            ...(placeItems !== undefined && { placeItems }),
            gap: resolvedGap,
            ...(alignItems === undefined && align !== undefined && { alignItems: align }),
            ...(justifyContent === undefined && justify !== undefined && { justifyContent: justify }),
        }),
        ...buildCommonUIProps({
            id,
            role,
            ariaLabel,
            ariaLabelledBy: ariaLabelledBy !== undefined ? ariaLabelledBy : ariaLabelledByAttribute,
            ariaDescribedBy,
            style,
            dataUi,
            defaultDataUi: 'Grid',
        }),
    };
    if (asChild) {
        return composeAsChildNode({
            componentType: 'Grid',
            props: gridProps,
            children,
            explicitDataUi: dataUi,
            semanticTagOverride: as,
        });
    }
    const childNodes = normalizeChildren(children);
    return {
        id: createNodeId(),
        type: 'Grid',
        props: gridProps,
        children: childNodes,
    };
}
function normalizeChildren(children) {
    return normalizeChildrenToNodes(children);
}
const gridDefaultUtilityProps = BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS.Grid;
const DEFAULT_GRID_COLUMNS = 1;
export const defaultGridProps = Object.freeze({
    gap: gridDefaultUtilityProps.gap,
});
//# sourceMappingURL=Grid.js.map